var _excluded = ["title", "content", "width", "icon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';
import ThemeProvider from "../ThemeProvider";
import Modal from "./Modal";
var ConfirmDialog = function ConfirmDialog(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? '提示' : _props$title,
    content = props.content,
    _props$width = props.width,
    width = _props$width === void 0 ? 480 : _props$width,
    icon = props.icon,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(Modal, _extends({
    title: /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: '22px',
        color: 'text.main',
        fontWeight: 500
      }
    }, icon ? icon : /*#__PURE__*/React.createElement(ErrorIcon, {
      sx: {
        color: '#FFBF00',
        mr: '16px',
        fontSize: '24px'
      }
    }), title),
    closable: false,
    keyboard: false,
    width: width
  }, rest), /*#__PURE__*/React.createElement(Box, {
    sx: {
      color: 'text.secondary',
      pl: '40px'
    }
  }, content)));
};
export default ConfirmDialog;